<template>
  <section>
    <div class="container">

      <div class="hero is-bold">
        <div class="hero-body" style="padding-left: 0px; padding-top: 0px">
          <div class="container">
            <h1 class="title" style="color:#3e8ed0">Clusters</h1>
            <h5 class="subtitle">Manage your clusters here. One cluster can have multiple devices assigned to it.</h5>
          </div>
        </div>
      </div>

      <div class="columns is-multiline is-mobile">
        <div class="column is-4 is-offset-1 box" v-for="(cluster,id) in clusters" :key="id">
          <div class="level">
            <div class="level-left">
              <router-link style="font-size:17.5px;color:#3e8ed0" class="level-item" :to="{ name: 'ClusterDetails', params: { id: id }}" ><b>{{showClusterName(cluster.name)}}</b></router-link>
            </div>
            <div class="level-right">
              <div class="level-item">
                <b-button icon-left="edit" class="button is-info" @click="editCluster(id)">Edit</b-button>
              </div>
              <div class="level-item">
                <b-button :disabled="role !== 'admin' && role !== 'device' && isMigrated" icon-left="trash" class="button is-danger" @click="confirmRemove(id)"></b-button>
              </div>
            </div>
          </div>
          <table>

  <tr>
    <td  style="padding-right: 10px"><b>Main playlist:</b></td>
    <td>{{getMainPlaylistName(cluster)}}</td>
  </tr>
            <tr>
    <td  style="padding-right: 10px"><b>No. of devices:</b></td>
    <td >{{getDevicesCount(id)}}</td>
  </tr>
</table>
          <!--<p>Main Playlist: {{getMainPlaylistName(cluster)}}</p>
          <p>Number of devices: {{getDevicesCount(id)}}</p>-->

        </div>
      <div></div>
      </div>

      <vue-fab v-if="!bAddCluster" title="Add Cluster" :scrollAutoHide="autoHide" mainBtnColor="#48c78e" icon="add" size="big" @clickMainBtn="addCluster" :hidden="role !== 'admin' && role !== 'device' && isMigrated"/>
    </div>
  </section>
</template>

<script>
import ClusterAddEdit from '@/components/clusters/ClusterAddEdit'

export default {
  name: 'Clusters',
  data: () => {
    return {
      bAddCluster: false,
      loadingComponent: null,
      autoHide: false,
      jsonResp: null
    }
  },
  created: function () {
    fetch('https://api.seeip.org/geoip').then(
      (response) => response.json()
    ).then(
      (jsonResponse) => {
        this.jsonResp = jsonResponse
        this.globalLogger(this.jsonResp)
      }
    )
  },
  computed: {
    clusters () {
      return this.$store.state.clusters
    },
    workspaceId () {
      return this.$store.state.workspaceId
    },
    role () {
      return this.$store.state.role
    },
    userId () {
      return this.$store.state.uid
    },
    isMigrated () {
      return !this.getNotMigrated().includes(this.$store.state.uid)
    }
  },
  methods: {
    addCluster () {
      this.bAddCluster = true
      this.$buefy.modal.open({
        parent: this,
        component: ClusterAddEdit,
        props: { propParentFn: this.cancelAdd },
        hasModalCard: true,
        trapFocus: true,
        onCancel: this.cancelAdd,
        canCancel: ['x']
      })
    },
    editCluster (id) {
      this.bAddCluster = true
      this.$buefy.modal.open({
        parent: this,
        component: ClusterAddEdit,
        props: { editEnabled: true, propId: id, propParentFn: this.cancelAdd },
        hasModalCard: true,
        trapFocus: true,
        onCancel: this.cancelAdd,
        canCancel: ['x']
        // width: 5000
      })
    },
    confirmRemove (id) {
      this.globalLogger('CONFIRM REMOVE')
      this.$buefy.dialog.confirm({
        title: 'Delete cluster',
        message: 'Are you sure you want to <b>delete</b> this cluster? This action cannot be undone.',
        confirmText: 'Delete',
        type: 'is-danger',
        onConfirm: () => this.removeCluster(id)
      })
    },
    removeCluster (id) {
      // LOGGING
      var clToRemove = this.$store.getters.getCluster(id)

      var clToRemoveLog = Object.assign({}, clToRemove)
      clToRemoveLog.ip_addr = this.jsonResp ? this.jsonResp.ip : ''
      clToRemoveLog.city = this.jsonResp ? this.jsonResp.city : ''
      var devices = this.$store.getters.getDevicesForCluster(id)
      var clDev = []
      for (let dev in devices) {
        clDev.push(dev + '|' + devices[dev].name)
      }
      clToRemoveLog.devices = clDev
      this.globalLogger(clToRemoveLog, 'cl to remove')
      this.$analytics.logEvent('delete_cluster', clToRemoveLog)
      // LOGGING END

      this.loadingComponent = this.$buefy.loading.open()
      let associatedDevicesRef = this.$store.getters.getDevicesForCluster(id)
      if (!this.getNotMigrated().includes(this.userId)) {
        for (let device in associatedDevicesRef) {
          this.$store.state.database.ref('/neoslide/devices/' + this.workspaceId + '/' + device).update({
            clusterId: ''
          })
        }
      } else {
        for (let device in associatedDevicesRef) {
          this.$store.state.database.ref('/devices/' + this.userId + '/' + device).update({
            clusterId: ''
          })
        }
      }
      let clusterCampaignsRef = null
      if (!this.getNotMigrated().includes(this.userId)) {
        clusterCampaignsRef = this.$store.state.database.ref('/neoslide/campaigns/' + this.workspaceId + '/' + id)
      } else {
        clusterCampaignsRef = this.$store.state.database.ref('/campaigns/' + this.userId + '/' + id)
      }
      if (clusterCampaignsRef !== null && clusterCampaignsRef !== undefined) {
        clusterCampaignsRef.remove()
      }
      let removeClusterRef = null
      if (!this.getNotMigrated().includes(this.userId)) {
        removeClusterRef = this.$store.state.database.ref('/neoslide/clusters/' + this.workspaceId + '/' + id)
      } else {
        removeClusterRef = this.$store.state.database.ref('/clusters/' + this.userId + '/' + id)
      }
      removeClusterRef.remove()
      setTimeout(() => this.loadingComponent.close(), 1000)
    },
    getDevicesCount (id) {
      return this.$store.getters.getDevicesCountForCluster(id)
    },
    getMainPlaylistName (cluster) {
      let retPlaylist = this.$store.getters.getPlaylist(cluster.mainPlaylistId)
      if (retPlaylist) {
        return retPlaylist.name
      } else {
        return 'None'
      }
    },
    cancelAdd () {
      this.bAddCluster = false
    },
    showClusterName (name) {
      if (name.length > 21) {
        return name.substr(0, 21) + '...'
      }
      return name
    }
  }
}
</script>

<style scoped>
  .box {
    border: 0.5px solid rgb(212, 212, 212);
  }
</style>



// WEBPACK FOOTER //
// src/components/clusters/Clusters.vue